import { LazyLoad } from 'app/utils';

export const NewsFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.NewsFormPage,
);
